<app-card size="large" [fullHeight]="true" [background]="!readOnlyMode">
  @if (isLoading()) {
  <app-spinner data-test-id="group-challenges-spinner"></app-spinner>
  } @else {
  <form [formGroup]="form" data-test-id="group-challenges-form">
    <div class="top-actions">
      <app-title-section
        title="{{ backTitle() | translate }}"
        backButton="true"
        [size]="TitleSize.SMALL"
        [spacingBottom]="TitleSpacing.NONE"
        (handlePressBack)="goBack()"
      ></app-title-section>
      @if (!isSaving() && !readOnlyMode) {
      <app-form-action-button
        type="save"
        (handleClick)="onSave()"
        data-test-id="group-challenges-save-button"
      ></app-form-action-button>
      } @else if (!isSaving() && readOnlyMode) {
      <app-form-action-button
        type="edit"
        (handleClick)="onSelectEdit()"
        data-test-id="group-challenges-edit-button"
      ></app-form-action-button>
      } @else if (isSaving()) {
      <app-spinner
        size="20px"
        thickness="1px"
        data-test-id="group-challenges-saving-spinner"
      ></app-spinner>
      }
    </div>
    <app-title-section
      title="{{ challengeTitle() }}"
      [size]="TitleSize.MEDIUM"
      [spacingBottom]="TitleSpacing.X_LARGE"
      body="All levels • {{ challengeWeeks() }} weeks"
      data-test-id="group-challenges-title-section-challenge"
    ></app-title-section>
    <app-input
      labelData="Title"
      variant="{{ InputVariant.OUTLINE }}"
      width="{{ InputWidth.FULL }}"
      spacingBottom="{{ InputFieldSpacing.X_LARGE }}"
      formControlName="title"
      [disabled]="readOnlyMode"
      [error]="!!errorMessages().title"
      [errorMessage]="errorMessages().title"
      [maxLength]="255"
      data-test-id="group-challenges-input-title"
    ></app-input>
    <app-input
      labelData="{{ 'groupChallenges.description' | translate }}"
      variant="{{ InputVariant.OUTLINE }}"
      width="{{ InputWidth.FULL }}"
      [multiLine]="true"
      spacingBottom="{{ InputFieldSpacing.X_LARGE }}"
      formControlName="description"
      [disabled]="readOnlyMode"
      [error]="!!errorMessages().description"
      [errorMessage]="errorMessages().description"
      data-test-id="group-challenges-input-description"
    ></app-input>
    <app-title-section
      title="Team Assignment"
      [size]="TitleSize.MEDIUM"
      [spacingBottom]="TitleSpacing.SMALL"
    ></app-title-section>
    <div
      class="team-assigment-options"
      data-test-id="group-challenges-team-assignment-options"
    >
      @for(option of teamAssignmentOptions; track option) {
      <div
        class="team-assigment-option"
        data-test-id="group-challenges-team-assignment-option-default"
      >
        <app-toggle
          (handleChecked)="onSelect(option.strategy)"
          [checked]="teamAssignmentStrategy() === option.strategy"
          [color]="ToggleHexColor.GREEN"
          [disabled]="readOnlyMode"
          size="small"
          [attr.data-test-id]="getAssignmentDataTestId(option.strategy)"
        ></app-toggle>
        <app-text
          [color]="TextColor.NEUTRAL_7"
          [size]="TextSize.BODY_2"
          [spacingBottom]="TextSpacing.MEDIUM"
          >{{ option.label | translate }}</app-text
        >
      </div>
      }
    </div>
    <div>
      @if( teamAssignmentStrategy() ===
      groupChallengeTeamAssignmentStrategy.DEFAULT){
      <app-text
        [color]="TextColor.NEUTRAL_7"
        [size]="TextSize.BODY_2"
        [spacingBottom]="TextSpacing.X_SMALL"
        class="team-assignment-title"
        data-test-id="group-challenges-default-assignment-title"
        >{{
          'groupChallenges.defaultTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        [color]="TextColor.NEUTRAL_6"
        [size]="TextSize.BODY_1"
        [weight]="TextWeight.REGULAR"
        [height]="TextHeight.BODY_1"
        [spacingBottom]="TextSpacing.MEDIUM"
        data-test-id="group-challenges-default-assigment-requirement"
        >{{
          'groupChallenges.defaultTeamAssignmentRequirement' | translate
        }}</app-text
      >
      <input formControlName="numberOfTeams" type="hidden" />
      <input formControlName="maxTeamNumber" type="hidden" />
      } @else if( teamAssignmentStrategy() ===
      groupChallengeTeamAssignmentStrategy.FIXED_TEAM_COUNT){
      <app-text
        [color]="TextColor.NEUTRAL_7"
        [size]="TextSize.BODY_2"
        [spacingBottom]="TextSpacing.X_SMALL"
        class="team-assigment-title"
        data-test-id="group-challenges-fixed-team-count-assigment-title"
        >{{
          'groupChallenges.fixCountTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        [color]="TextColor.NEUTRAL_6"
        [size]="TextSize.BODY_1"
        [weight]="TextWeight.REGULAR"
        [height]="TextHeight.BODY_1"
        [spacingBottom]="TextSpacing.MEDIUM"
        data-test-id="group-challenges-fixed-team-count-assigment-requirement"
        >{{
          'groupChallenges.fixCountTeamAssignmentRequirement' | translate
        }}</app-text
      >
      <app-input
        labelData="{{
          'groupChallenges.fixCountTeamAssignmentNote' | translate
        }}"
        variant="{{ InputVariant.OUTLINE }}"
        width="{{ InputWidth.FIXED_NUMBER }}"
        type="{{ InputType.NUMBER }}"
        formControlName="numberOfTeams"
        spacingBottom="{{ InputFieldSpacing.X_LARGE }}"
        [disabled]="readOnlyMode"
        [error]="!!errorMessages().numberOfTeams"
        [errorMessage]="errorMessages().numberOfTeams"
        data-test-id="group-challenges-input-number-of-teams"
        [maxLength]="3"
      ></app-input>
      <input formControlName="numberOfTeams" type="hidden" />
      <input formControlName="maxTeamNumber" type="hidden" />
      } @else if( teamAssignmentStrategy() ===
      groupChallengeTeamAssignmentStrategy.FIXED_TEAM_SIZE){

      <app-text
        [color]="TextColor.NEUTRAL_7"
        [size]="TextSize.BODY_2"
        [spacingBottom]="TextSpacing.X_SMALL"
        class="team-assigment-title"
        data-test-id="group-challenges-fixed-team-size-assigment-title"
        >{{
          'groupChallenges.maxTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        [color]="TextColor.NEUTRAL_6"
        [size]="TextSize.BODY_1"
        [weight]="TextWeight.REGULAR"
        [height]="TextHeight.BODY_1"
        [spacingBottom]="TextSpacing.MEDIUM"
        data-test-id="group-challenges-fixed-team-size-assigment-requirement"
        >{{
          'groupChallenges.maxTeamAssignmentRequirement' | translate
        }}</app-text
      >
      <app-input
        labelData="{{ 'groupChallenges.maxTeamAssignmentNote' | translate }}"
        variant="{{ InputVariant.OUTLINE }}"
        type="{{ InputType.NUMBER }}"
        width="{{ InputWidth.FIXED_NUMBER }}"
        formControlName="maxTeamNumber"
        spacingBottom="{{ InputFieldSpacing.X_LARGE }}"
        [disabled]="readOnlyMode"
        [error]="!!errorMessages().maxTeamNumber"
        [errorMessage]="errorMessages().maxTeamNumber"
        data-test-id="group-challenges-input-number-of-teams"
        [maxLength]="3"
      ></app-input>
      <input formControlName="numberOfTeams" type="hidden" />
      <input formControlName="maxTeamNumber" type="hidden" />
      } @else{
      <input formControlName="numberOfTeams" type="hidden" />
      <input formControlName="maxTeamNumber" type="hidden" />
      <app-text
        [color]="TextColor.NEUTRAL_7"
        [size]="TextSize.BODY_2"
        [spacingBottom]="TextSpacing.X_SMALL"
        class="team-assigment-title"
        data-test-id="group-challenges-manual-team-assigment-title"
        >{{
          'groupChallenges.manualTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        [color]="TextColor.NEUTRAL_6"
        [size]="TextSize.BODY_1"
        [weight]="TextWeight.REGULAR"
        [height]="TextHeight.BODY_1"
        [spacingBottom]="TextSpacing.MEDIUM"
        data-test-id="group-challenges-manual-team-assigment-requirement"
        >{{
          'groupChallenges.manualTeamAssignmentRequirement' | translate
        }}</app-text
      >
      <app-challenge-teams
        [teams]="challenge().teams"
        (teamsChanged)="onTeamsChanged($event)"
        [disabled]="readOnlyMode || isSaving()"
        data-test-id="group-challenges-manual-team-assigment-section"
      ></app-challenge-teams>

      }
    </div>

    <app-title-section
      title="Dates"
      [size]="TitleSize.MEDIUM"
      [spacingBottom]="TitleSpacing.LARGE"
    ></app-title-section>
    <div class="date-wrapper" data-test-id="group-challenges-date-wrapper">
      @if( teamAssignmentStrategy() !==
      groupChallengeTeamAssignmentStrategy.MANUAL){
      <app-input
        labelData="{{ 'groupChallenges.signupDate' | translate }}"
        variant="{{ InputVariant.OUTLINE }}"
        type="{{ InputType.DATE }}"
        width="{{ InputWidth.FIXED_DATE }}"
        class="top-left"
        formControlName="signupDate"
        [disabled]="readOnlyMode"
        [error]="!!errorMessages().signupDate"
        [errorMessage]="errorMessages().signupDate"
        data-test-id="group-challenges-input-signup-date"
      ></app-input>
      }
      <app-input
        labelData="{{ 'groupChallenges.startDate' | translate }}"
        variant="{{ InputVariant.OUTLINE }}"
        type="{{ InputType.DATE }}"
        width="{{ InputWidth.FIXED_DATE }}"
        class="bottom-left"
        formControlName="startDate"
        [disabled]="readOnlyMode"
        [error]="!!errorMessages().startDate"
        [errorMessage]="errorMessages().startDate"
        [dateRestriction]="inputDateRestriction.FUTURE_ONLY"
        data-test-id="group-challenges-input-start-date"
      ></app-input>
      <app-input
        labelData="{{ 'groupChallenges.endDate' | translate }}"
        type="{{ InputType.DATE }}"
        info="{{ 'groupChallenges.endDateInfo' | translate }}"
        width="{{ InputWidth.FIXED_DATE }}"
        class="bottom-right"
        formControlName="endDate"
        [disabled]="true"
        data-test-id="group-challenges-input-end-date"
      ></app-input>
    </div>
    <div
      class="challenge-options"
      data-test-id="group-challenges-options"
      *ngIf="
        teamAssignmentStrategy() !== groupChallengeTeamAssignmentStrategy.MANUAL
      "
    >
      <app-toggle
        (handleChecked)="handleCheck()"
        [checked]="checked"
        [color]="ToggleHexColor.GREEN"
        [disabled]="readOnlyMode"
        size="small"
        class="top-left"
        data-test-id="group-challenges-toggle-allow-joining"
      ></app-toggle>
      <app-text
        class="top-right"
        [color]="TextColor.NEUTRAL_7"
        [size]="TextSize.BODY_2"
        >{{
          'groupChallenges.allowJoiningAfterStartHeader' | translate
        }}</app-text
      >
      <app-text
        class="bottom-right"
        [color]="TextColor.NEUTRAL_6"
        [size]="TextSize.BODY_1"
        [weight]="TextWeight.REGULAR"
        [height]="TextHeight.BODY_1"
        >{{
          'groupChallenges.allowJoiningAfterStartBody' | translate
        }}</app-text
      >
    </div>
  </form>
  }
</app-card>

<app-save-changes-confirmation
  [navigate]="goBackNavigate"
  data-test-id="group-challenges-save-changes-confirmation"
></app-save-changes-confirmation>
